import { render, staticRenderFns } from "./ReferenceStandard.vue?vue&type=template&id=d8b0678e&scoped=true"
import script from "./ReferenceStandard.vue?vue&type=script&lang=js"
export * from "./ReferenceStandard.vue?vue&type=script&lang=js"
import style0 from "./ReferenceStandard.vue?vue&type=style&index=0&id=d8b0678e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b0678e",
  null
  
)

export default component.exports